<template>
	<v-app>
		<LoadingPageWithQuote v-if="isSwitchFormationStateLoading" />
		<ConnectEoloquenceRequest v-if="!isSwitchFormationStateLoading" />
		<TrialFinished
			v-if="
				formationInfos.test_trial &&
				this.$router.currentRoute.name != 'Onboarding' &&
				this.$router.currentRoute.name != 'TestPositionnement' &&
				Object.keys(formationInfos).length != 0 &&
				this.$router.currentRoute.name != 'ResultsDetail'
			"
		/>
		<!-- hidded 13/05/2024
		<Announcement
			v-if="
				!formationInfos.test_trial &&
				this.$router.currentRoute.name != 'Onboarding' &&
				this.$router.currentRoute.name != 'TestPositionnement' &&
				Object.keys(formationInfos).length != 0 &&
				this.$router.currentRoute.name != 'ResultsDetail'
			"
		></Announcement> -->
		<CookieConsent />
		<NavBar
			:categoriesDone="categoriesDone"
			:formationInfos="formationInfos"
			:currentRoute="this.$router.currentRoute"
		/>
		<v-content>
			<router-view v-if="accessToApp"></router-view>
			<NotOptimized v-else></NotOptimized>
		</v-content>
		<WebPushNotificationPermission />
	</v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import { initializeApp } from 'firebase/app';
import { getMessaging, onMessage } from 'firebase/messaging';
import { firebaseConfig } from '@/config/firebase-messaging.js';
import firebaseMessaging from '@/utils/firebase-messaging.js';

import '@/assets/styles.css';
import '@/assets/css/custom-introjs.scss';
import NotOptimized from '@/views/layouts/NotOptimized';
import TrialFinished from '@/components/other/TrialFinished';
// import Announcement from './components/layouts/Announcement';
import NavBar from './components/navbar/index.vue';
import { setAppContextOnLocalStorage } from './utils/context';
import CookieConsent from '@/components/cookie-consent/CookieConsent.vue';
import LoadingPageWithQuote from './components/loading-page-with-quote/LoadingPageWithQuote.vue';
import WebPushNotificationPermission from './components/other/WebPushNotificationPermission.vue';
import ConnectEoloquenceRequest from './components/other/ConnectEoloquenceRequest.vue';
// import { sienna } from './libraries/sienna';

/** Firebase registered */
if (navigator.serviceWorker) {
	initializeApp(firebaseConfig);
	const messaging = getMessaging();
	onMessage(messaging, firebaseMessaging.onReceiveMessage);
}

export default {
	name: 'App',
	components: {
		NotOptimized,
		LoadingPageWithQuote,
		TrialFinished,
		NavBar,
		// Announcement,
		CookieConsent,
		WebPushNotificationPermission,
		ConnectEoloquenceRequest,
	},
	computed: {
		...mapGetters('profile', {
			formationInfos: 'formationInfos',
			categoriesDone: 'categoriesDone',
		}),
		...mapGetters('appState', {
			selectingFormationId: 'selectingFormationId',
			isSwitchFormationStateLoading: 'isSwitchFormationStateLoading',
		}),
	},
	data: () => {
		return {
			accessToApp: true,
			openMenu: false,
		};
	},
	methods: {
		setAppContextOnLocalStorage,
		async fetchAndSetAllFormationsAndTopic() {
			if (localStorage.getItem('token') == null) return;
			await this.$store.dispatch('profile/fetchAllFormationsAndTopic');
		},
	},
	async created() {
		try {
			this.setAppContextOnLocalStorage();
			this.fetchAndSetAllFormationsAndTopic();
		} catch (error) {
			console.error(error);
		}
	},
	watch: {
		selectingFormationId() {
			this.$store.dispatch('profile/getProfileFormationInfos', { formationId: this.selectingFormationId });
		},
	},
};
</script>
